import React from 'react'
import { Navigate } from 'react-router-dom'
import { ROUTES } from '@/constants'
import { useTenantContext } from '@/context'
import { getDefaultDonatePath } from '@/utils/primary-donation-nav'

export const DonateLandingRedirect = () => {
  const { tenant, loadingTenant } = useTenantContext()

  if (loadingTenant) {
    return null
  }

  const target = getDefaultDonatePath(tenant)
  if (target == null) {
    return <Navigate to={ROUTES.DONATE_NAV_NOT_CONFIGURED} replace />
  }

  return <Navigate to={target} replace />
}
